import styled,{css} from 'styled-components';

export const Container = styled.div`
  display: flex;
  width:100%;
  max-width:100%;
  height:100%;
  flex-direction: column;
  justify-content: center;
`;
export const Name = styled.div`
  display: flex;
  width:100%;
  height:4.5rem;
  margin-top: 1rem;
  padding: 1rem;
  flex-direction: column;
  gap: 1rem;

  label{
    font-size: 1.1rem;
    color: #000000;
  }

  div{
    display: flex;
    width: 100%;
    height: 2.5rem;
    border-radius: 6px;
    padding: 0.5rem;
    background-color: #f5f5f5;
    border: 1px solid #f5f5f5;
  }
  
  input{
    outline: none;
    border: none;
    width: 100%;
    font-size: 15px;
    color: #4a4a4a;
    background-color: transparent;
  }
`;
export const Action = styled.div`
  display: flex;
  width:100%;
  height:2.5rem;
  padding-right: 1rem;
  justify-content: right;

  button{
    outline: none;
    border: none;
    width: 7rem;
    border-radius: 6px;
    cursor: pointer;
    color: #1983e2;
    background-color: transparent;
    border: 1px solid #1983e2;
  }

  button:hover{
    background-color: #e7f0fe;
  }
`;
export const Result = styled.div`
  display: flex;
  width:100%;
  height:13rem;
  flex-direction: column;
  padding:1rem;
  gap: 0.5rem;

  ${({isEnable}) => !isEnable &&
   css`
      &{
        pointer-events: none;
        user-select: none;
        opacity: 0.4;
      }
    `
  };

  span{
    width: 100%;
    border-top: 1px solid;
  }

  label{
    font-size: 1.1rem;
    color: #4a4a4a;
  }

  .link{
    display: flex;
    width: 100%;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 1px solid #dedede;
    padding: 0.5rem;
    gap: 0.5rem;
  }

  .copy{
    display: flex;
    outline: none;
    border: none;
    width: 6rem;
    height: 2rem;
    margin-top: 0.5rem;
    padding: 0.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    border: 1px solid;
    cursor: pointer;
    background-color: transparent;
  }

  input{
    outline: none;
    border: none;
    width: 100%;
    overflow-x: scroll;
  }

  .icon{
    font-size: 1.2rem;
    margin-left: 0.5rem;
  }

`;